export default {
  ENTRIES:    'entries',
  INSIGHTS:   'insights',
  REWARDS:    'rewards',
  PROMOTIONS: 'promotions',
};
